import { getDamageImageFileGroupKey, getDamageImageUrl } from '../../../utils/damageGrouping';
import type { InspectionMediaData } from '../inspectionMediaTypes';
import { getDamageLookupImageUri } from './damageAnnotationUtils';

type HistoryDamageLike = {
  id?: string;
  history?: unknown;
  imageFileId?: string;
  imageURI?: string;
  imageUrl?: string;
  imagePath?: string;
  image?: string;
  imageFileGroupKey?: string;
  isDeleted?: boolean | string | number;
};

export const getDamageHistoryEntries = (damage?: HistoryDamageLike | null): unknown[] => {
  const history = damage?.history;
  return Array.isArray(history) ? history : [];
};

export const isDamageOnImage = (damage: HistoryDamageLike, imageData?: InspectionMediaData | null): boolean => {
  if (!imageData) {
    return false;
  }

  if (damage.id && (imageData.damageId === damage.id || (imageData.damages ?? []).some(item => item?.id === damage.id))) {
    return true;
  }

  if (imageData.imageFileId && damage.imageFileId && String(imageData.imageFileId) === String(damage.imageFileId)) {
    return true;
  }

  const imageUri = getDamageLookupImageUri(imageData);
  const damageUri = getDamageLookupImageUri({
    imageURI: getDamageImageUrl(damage),
  });
  if (imageUri && damageUri && imageUri === damageUri) {
    return true;
  }

  if (!imageData.imageFileId && !imageData.imageURI && !imageData.src) {
    return false;
  }

  return getDamageImageFileGroupKey(damage) === getDamageImageFileGroupKey(imageData);
};

export const imageHasAnnotationHistory = (
  damages: HistoryDamageLike[] | undefined,
  imageData?: InspectionMediaData | null
): boolean => {
  if ((imageData?.damages ?? []).some(damage => getDamageHistoryEntries(damage).length > 0)) {
    return true;
  }

  return (damages ?? []).some(damage => isDamageOnImage(damage, imageData) && getDamageHistoryEntries(damage).length > 0);
};
